import React from 'react'
import { ACTIVE, DISABLED, STATUS_PENDING, STATUS_INFLUENCER_ACCEPTED, STATUS_ACCEPTED, STATUS_AGENCY_ACCEPTED, STATUS_APPROVED, STATUS_REJECTED, STATUS_AGENCY_REJECTED, STATUS_INFLUENCER_REJECTED, STATUS_PRIVATE, STATUS_PUBLIC, STATUS_CLOSED, USER_ACTIVE, STATUS_STOPPED, STATUS_STARTED, STATUS_COMPLETED } from '../../constants'
import { FaBitcoin, FaMedal } from 'react-icons/fa'
import { GiRibbonMedal } from 'react-icons/gi'
import { RiMedal2Fill } from 'react-icons/ri'
import { IoMedalOutline } from 'react-icons/io5'
import { FormattedMessage } from 'react-intl'

const Tag = ({ bg, text, custom_size }) => {
    return (
        <div>
            <div className={`text-xs  ${custom_size ? custom_size : "min-w-[90px] px-3 rounded-full"}   py-1 ${bg} text-center uppercase`}>
                {text}
            </div>
        </div>
    )
}

export default Tag





export const StatusTag = ({ status, custom_size }) => {
    return (

        status === STATUS_PENDING.value ?
            <Tag bg={`${STATUS_PENDING.backgroundColor} ${STATUS_PENDING.textColor}`} text={<FormattedMessage id="pending" defaultMessage={"Pending"} />} />
            // :status=== CONFIRMED ?
            //     <Tag  bg="bg-status-confirmed" text="Confirmed"  />
            : status === STATUS_INFLUENCER_ACCEPTED.value ?
                <Tag bg={`${STATUS_INFLUENCER_ACCEPTED.backgroundColor} ${STATUS_INFLUENCER_ACCEPTED.textColor}`} text={<FormattedMessage id="in-review" defaultMessage={"In Review"} />} />
                : status === STATUS_ACCEPTED.value || status === STATUS_AGENCY_ACCEPTED.value ?
                    <Tag bg={`${STATUS_AGENCY_ACCEPTED.backgroundColor} ${STATUS_AGENCY_ACCEPTED.textColor}`} text={<FormattedMessage id="accepted" defaultMessage={"Accepted"} />} />
                    : status === STATUS_APPROVED.value ?
                        <Tag bg={`${STATUS_APPROVED.backgroundColor} ${STATUS_APPROVED.textColor}`} text={<FormattedMessage id="approved" defaultMessage={"Approved"} />} />
                        : status === STATUS_PRIVATE.value ?
                            <Tag bg={`${STATUS_PRIVATE.backgroundColor} ${STATUS_PRIVATE.textColor}`} text={<FormattedMessage id="private" defaultMessage={"Private"} />} />
                            : status === STATUS_COMPLETED.value ?
                                    <Tag bg={`${STATUS_COMPLETED.backgroundColor} ${STATUS_COMPLETED.textColor}`} text={<FormattedMessage id="completed" defaultMessage={"Completed"} />} />
                            : status === STATUS_PUBLIC.value ?
                                <Tag bg={`${STATUS_PUBLIC.backgroundColor} ${STATUS_PUBLIC.textColor}`} text={<FormattedMessage id="public" defaultMessage={"Public"} />} />
                                : status === STATUS_CLOSED.value ?
                                    <Tag bg={`${STATUS_CLOSED.backgroundColor} ${STATUS_CLOSED.textColor}`} text={<FormattedMessage id="closed" defaultMessage={"Closed"} />} />
                                    : status === USER_ACTIVE.value ?
                                        <Tag bg={`${STATUS_APPROVED.backgroundColor} ${STATUS_APPROVED.textColor}`} text={<FormattedMessage id="active" defaultMessage={"Active"} />} />
                                        : status === STATUS_STOPPED.value ?
                                            <Tag bg={`${STATUS_STOPPED.backgroundColor} ${STATUS_STOPPED.textColor}`} text={<FormattedMessage id="stopped" defaultMessage={"Stopped"} />} />
                                            : status === STATUS_STARTED.value ?
                                                <Tag bg={`${STATUS_STARTED.backgroundColor} ${STATUS_STARTED.textColor}`} text={<FormattedMessage id="started" defaultMessage={"Started"} />} />
                                                : status === STATUS_REJECTED.value || status === STATUS_AGENCY_REJECTED.value || status === STATUS_INFLUENCER_REJECTED.value ?
                                                    <Tag bg={`${STATUS_REJECTED.backgroundColor} ${STATUS_REJECTED.textColor}`} text={<FormattedMessage id="rejected" defaultMessage={"Rejected"} />} />
                                                    : (status === ACTIVE || status === true) ?
                                                        <Tag bg="bg-green-500/70" text={"Active"} custom_size={custom_size} />
                                                        : status === DISABLED || status === false ?
                                                            <Tag bg="bg-red-500/80" text={"Disabled"} custom_size={custom_size} />
                                                            // :status === NOT_APPROVED ?
                                                            //    <Tag bg="bg-status-not_approved" text={"pending"} custom_size={custom_size} />  
                                                            : <p className='text-red-500'>{status}</p>

    )
}






